import { render, staticRenderFns } from "./NPJcomReport.vue?vue&type=template&id=989d9070"
import script from "./NPJcomReport.vue?vue&type=script&lang=js"
export * from "./NPJcomReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports